import $ from "jquery";

$(function () {
	let moreBtn = $(".header .more-trigger, .header .close-more-menu, .menu-button-container");

	moreBtn.on("click", function (e) {
		e.preventDefault();
		$("body, html").toggleClass("js-more-menu-open");
	});

	$(".more-nav .menu-item a").on("click", function () {
		$("body, html").toggleClass("js-more-menu-open");
	});

	// Close burger menu when clicking anchor links in main nav
	$(".main-nav .menu-item a").on("click", function () {
		if (this.hash !== "") {
			$("body, html").removeClass("js-more-menu-open");
		}
	});
});
